/**
 * PRAZO PARA QUALQUER ESPERA DA TELA.
 *
 * Dentro do aplicativo instalado, boa parte do que a tela espera não é código
 * nosso: é a ponte com o Android, o Firebase e o servidor pela rede do
 * celular. Qualquer uma dessas pontas pode simplesmente NÃO RESPONDER — sem
 * erro, sem fim —, e aí o `await` fica pendurado para sempre e o botão gira
 * sem parar (relato do Leandro, 23/10/2026: primeiro o cartão, depois o
 * botão "Ativar notificações").
 *
 * A regra que vale daqui em diante: nenhuma espera dessas sem prazo. Vencido
 * o prazo, a tela segue com o valor combinado e diz à pessoa o que não
 * respondeu — pior que falhar é não acabar nunca.
 *
 * A promessa recusada também cai no valor combinado: para quem está olhando
 * a tela, "deu erro" e "não respondeu" têm a mesma saída.
 */
export function comPrazo<T>(
  promessa: Promise<T>,
  ms: number,
  aoVencer: T,
): Promise<T> {
  return new Promise<T>((resolve) => {
    let pronto = false;
    const terminar = (v: T) => {
      if (pronto) return;
      pronto = true;
      clearTimeout(timer);
      resolve(v);
    };
    const timer = setTimeout(() => terminar(aoVencer), ms);
    promessa.then(
      (v) => terminar(v),
      () => terminar(aoVencer),
    );
  });
}
